import { css } from '@emotion/react'
import { Icon, VFlow } from 'bold-ui'
import { NavigationButton } from 'components/route/NavigationButton'
import { MChatRiscoEnum } from 'graphql/types.generated'
import { useRouteMatch } from 'react-router'

import { ACOMPANHAMENTO_CRIANCA_URL_MODAL } from '../../../aside/acompanhamento-puericultura/model'
import { MChatRfAccordion } from './components/MChatRfAccordion'
import { ConsultaSeguimentoView } from './consulta-seguimento/consulta-seguimento-view/ConsultaSeguimentoView'
import { MChatView } from './mchat/mchat-view/MChatView'
import { MChatRfViewModel } from './model-mChatRf'

interface MChatRfViewProps {
  value: MChatRfViewModel
}

export function MChatRfView(props: Readonly<MChatRfViewProps>) {
  const { value } = props

  const match = useRouteMatch()
  const modalAcompanhamentoCriancaUrl = `${match.url}${ACOMPANHAMENTO_CRIANCA_URL_MODAL}`

  const isMChatRiscoMedio = value?.mchat?.risco === MChatRiscoEnum.MEDIO
  const hasMChatAnteriorOrConsultaSeguimento = !!value?.mchat || !!value?.consultaSeguimento

  return (
    <MChatRfAccordion>
      <VFlow vSpacing={0}>
        {value?.mchat && <MChatView value={value.mchat} />}
        {value?.consultaSeguimento && (
          <ConsultaSeguimentoView value={value.consultaSeguimento} isMChatRiscoMedio={isMChatRiscoMedio} />
        )}
      </VFlow>
      {hasMChatAnteriorOrConsultaSeguimento && (
        <NavigationButton
          kind='primary'
          size='small'
          skin='outline'
          style={styles.section}
          to={{
            pathname: modalAcompanhamentoCriancaUrl,
            state: { focusTitle: true },
          }}
        >
          <Icon icon='zoomOutline' style={styles.icon} />
          Histórico de resultados
        </NavigationButton>
      )}
    </MChatRfAccordion>
  )
}

const styles = {
  section: css`
    margin: 1rem;
  `,
  icon: css`
    margin-right: 0.5rem;
  `,
}
